import React, { useState, useEffect } from "react";
import QRCode from "qrcode";
import pdfMake from "pdfmake/build/pdfmake";
import {FormattedMessage} from 'react-intl';
import pdfFonts from "pdfmake/build/vfs_fonts";
import Config from '../../commons/config/Config.js'
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function QRGenerator() {
  const [qrImgUrl, setQrImgUrl] = useState(null);
  // Generar QR y devolver la imagen base64
  const generateQR = async () => {
    const token = ConfigBusiness.get('reportarIncidentes.tokenUrl');
    const url = `${window.location.origin}/reporte-formulario/${token}`;

    const qrSize = 700;
    const squareSize = 250;

    const qrDataUrl = await QRCode.toDataURL(url, {
      errorCorrectionLevel: "H",
      margin: 1,
      width: qrSize,
    });

    const loadImageBase64 = async (url) => {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    const logoBase64 = await loadImageBase64(
      process.env.PUBLIC_URL + "/images/company/logo-login-app.png"
    );

    const canvas = document.createElement("canvas");
    canvas.width = qrSize;
    canvas.height = qrSize;
    const ctx = canvas.getContext("2d");

    const qrImg = new Image();
    qrImg.src = qrDataUrl;
    await new Promise((resolve) => (qrImg.onload = resolve));
    ctx.drawImage(qrImg, 0, 0, qrSize, qrSize);

    const logoImg = new Image();
    logoImg.src = logoBase64;
    await new Promise((resolve) => (logoImg.onload = resolve));

    const x = (qrSize - squareSize) / 2;
    const y = (qrSize - squareSize) / 2;
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(x, y, squareSize, squareSize);

    const logoAspect = logoImg.width / logoImg.height;
    let logoWidth = squareSize;
    let logoHeight = squareSize;
    if (logoAspect > 1) {
      logoHeight = squareSize / logoAspect;
    } else {
      logoWidth = squareSize * logoAspect;
    }
    const logoX = x + (squareSize - logoWidth) / 2;
    const logoY = y + (squareSize - logoHeight) / 2;
    ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

    return canvas.toDataURL("image/png");
  };

  // Generar QR al montar el componente
  useEffect(() => {
    generateQR().then(setQrImgUrl);
    // eslint-disable-next-line
  }, []);

  const generatePDF = async () => {
    const pdfImageWidth = 550;
    if (!qrImgUrl) return;
    const docDefinition = {
      pageSize: "A4",
      pageMargins: [0, 0, 0, 0],
      content: [
        {
          image: qrImgUrl,
          width: pdfImageWidth,
          alignment: "center",
          margin: [0, 120, 0, 0],
        },
      ],
    };
    pdfMake.createPdf(docDefinition).download("qr-vecfleet.pdf");
  };

  return (
    <div className="flex flex-col items-center">
      <button
        onClick={generatePDF}
        className="btn btn-primary"
      >
        <FormattedMessage id="Reportar_Incidente_Generar_QR" defaultMessage="Generar QR"/>
      </button>
      <div className="mt-8 flex justify-center items-center w-full" style={{ minHeight: 420 }}>
        {qrImgUrl && (
          <img src={qrImgUrl} alt="QR generado" style={{ width: 400, height: 400, objectFit: 'contain', display: 'block', margin: '0 auto' }} />
        )}
      </div>
    </div>
  );
}
